export interface NavDataProps {
  link: string;
  title: string;
  footer_title?: string;
}

export const navData: NavDataProps[] = [
  // {
  //   title: 'ОДКБ',
  //   link: '/odkb',
  // },
  {
    title: 'Интервью',
    link: '/intervyus',
  },
  {
    title: 'Аналитика',
    link: '/analitics',
  },
  {
    title: 'Сборник',
    link: '/sbornik',
  },
  {
    title: 'Авторам',
    link: '/authors',
  },
  {
    title: 'Контакты',
    link: '/contacts',
  },
  {
    title: '80 лет Великой Победы!',
    link: '/pobeda',
    footer_title: 'Победа'
  },
  {
    title: 'Медиа',
    link: '/media',
  },
];
